<div>
  <form [formGroup]="form">
    <ion-row class="notes">
      <ion-col size="12">
        <ion-row>
          <ion-col size="12" class="section-header">
            {{ CONSTS.HEADER }}
          </ion-col>
        </ion-row>

        <ion-row>
          <!-- SSC Description -->
          <ion-col size="6">
            <div class="form-group">
              <label [for]="CONTROLS.SSC_DESCRIPTION">
                {{ CONSTS.SSC_DESCRIPTION }}
              </label>
              <textarea
                rows="4"
                class="form-control"
                type="text"
                [formControlName]="CONTROLS.SSC_DESCRIPTION"
              ></textarea>
            </div>
          </ion-col>

          <!-- Additional Information  -->
          <ion-col size="6">
            <div class="form-group">
              <label [for]="CONTROLS.ADDITIONAL_INFORMATION">
                {{ CONSTS.ADDITIONAL_INFORMATION }}
              </label>
              <textarea
                rows="4"
                class="form-control"
                type="text"
                [placeholder]="CONSTS.ADDITIONAL_INFORMATION_PLACEHOLDER"
                [formControlName]="CONTROLS.ADDITIONAL_INFORMATION"
              ></textarea>
            </div>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="12">
            <div class="form-group">
              <label [for]="CONTROLS.DRIVER_REPLY">
                {{ CONSTS.DRIVER_REPLY }}
              </label>
              <textarea
                rows="4"
                class="form-control"
                type="text"
                [formControlName]="CONTROLS.DRIVER_REPLY"
              ></textarea>
            </div>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </form>
</div>
